module.exports = __webpack_public_path__ + "img/03.fc4e0e34.png";